import * as React from 'react';
import { Typography } from 'antd';
const { Title, Text, Paragraph } = Typography;
import { ISODate } from 'client/ui/display/date/ISODate';
import { IProcedure } from 'common/schema/Procedure';
import './ProcedureFrontTableTitle.scss';
import { ProcedureStateTag } from 'client/components/schema/procedures/status/ProcedureStateTag';
import { ProcedureFrontTableActions } from './ProcedureFrontTableActions';
import { ProcedureRecipientIcon } from '../recipient/ProcedureRecipientIcon';
import { ProcedureRecipientTitle } from '../recipient/ProcedureRecipientTitle';
import { useConfigRecipientEnabled } from '../hooks/useConfigRecipientEnabled';
import { useTranslation } from 'react-i18next';
import { ProcedureLogic } from 'common/schema/ProcedureLogic';

export interface ProcedureFrontTableTitleProps {
  procedure: IProcedure;
}

export function ProcedureFrontTableTitle(props: ProcedureFrontTableTitleProps) {
  const { procedure } = props;
  const { t } = useTranslation();
  const recipientEnabled = useConfigRecipientEnabled();

  return (
    <div className="procedure-front-table-cell-title">
      <Paragraph className="procedure-tag-dates">
        <span className="procedure-tag">
          <ProcedureStateTag procedure={procedure} />
          {recipientEnabled && (
            <span className="procedure-recipient">
              <ProcedureRecipientIcon recipient={procedure.recipient} />
              <ProcedureRecipientTitle recipient={procedure.recipient} />
            </span>
          )}
        </span>
        <span className="procedure-date">
          <Text type="secondary">
            {t('procedures.properties.from.activated-at', 'Decorrenza')}:{' '}
          </Text>
          <Text strong>
            <ISODate date={procedure.activatedAt} />
          </Text>
        </span>
        <span className="procedure-date">
          <Text type="secondary">
            {t('procedures.properties.from.expires-at', 'Scadenza')}:{' '}
          </Text>
          <Text strong>
            <ISODate
              date={ProcedureLogic.getRenderableDateWith24Hour(
                procedure.expiresAt
              )}
            />
          </Text>
        </span>
      </Paragraph>
      <Title className="procedure-title" level={3}>
        {procedure.title}
      </Title>
      <Paragraph className="procedure-categories">
        {procedure.categories.map((category, i) => (
          <Text type="secondary" key={i}>
            {category}
          </Text>
        ))}
      </Paragraph>
      <ProcedureFrontTableActions to={`/domande/${procedure.id}`} mobileOnly />
    </div>
  );
}
